import React, { useState, useEffect, useCallback, useRef } from "react";
import { ReactComponent as LockIcon } from "../../../../Assets/Icons/lock_24dp_.svg";
import { ReactComponent as ImagesIcon } from "../../../../Assets/Icons/imagesmode_24dp.svg";
import { ReactComponent as VideoIcon } from "../../../../Assets/Icons/videocam_24dp.svg";
import { ReactComponent as LugathJSPackageIcon } from "../../../../Assets/Images/lugath-js-package.svg";
import { ReactComponent as LugathJSCode } from "../../../../Assets/Images/lugath-js-code.svg";
import { ReactComponent as LoadingIcon } from "../../../../Assets/Icons/progress_activity_24dp.svg";
import { ReactComponent as LinkIcon } from "../../../../Assets/Icons/link_24dp.svg";
import { ReactComponent as CursorIcon } from "../../../../Assets/Icons/cursor.svg";
import { ReactComponent as GrabbingIcon } from "../../../../Assets/Icons/grabbing.svg";
import { ReactComponent as LugathLogo } from "../../../../Assets/Icons/logo-t.svg";
import Typed from "typed.js";
import anime from "animejs/lib/anime.es.js";
import "./index.scss";

export default function BrowserIntegrationAnimation({ showCaseRef }) {
  const _animationREF = React.useRef(null);
  const descriptionWrapperRef = React.useRef(null);
  const descriptionRef = React.useRef(null);
  const cursorWrapperRef = useRef(null);
  const cursorPulseRef = useRef(null);
  const urlInputRef = useRef(null);
  const urlInputValueRef = useRef(null);
  const selectedLangRef = useRef(null);
  const selectedLangValueRef = useRef(null);
  const langPickerFROptionRef = useRef(null);
  const langPickerESOptionRef = useRef(null);
  const langPickerJAOptionRef = useRef(null);
  const langPickerWrapperRef = useRef(null);
  const langPickerRef = useRef(null);
  const langPickerOptionsRef = useRef(null);
  const cursorRef = useRef(null);
  const animationWrapperRef = useRef(null);
  const packageWrapperRef = useRef(null);
  const packageRef = useRef(null);
  const cubeRef = useRef(null);
  const frameWindowWrapperRef = useRef(null);
  const [initialized, setInitialized] = useState(false);
  const typeAnimation = false;

  const languages = [
    {
      code: "EN",
      content: "Hello World!",
    },
    {
      code: "JA",
      content: "「こんにちは世界」",
    },
    {
      code: "FR",
      content: "Bonjour le monde!",
    },
    {
      code: "ES",
      content: "¡Hola Mundo!",
    },
  ];

  const [activeLang, setActiveLang] = useState({
    code: "EN",
    content: "Hello World!",
  });

  const animationController = (() => {
    const init = () => {
      if (initialized) {
        return;
      } else {
        console.log("init", initialized);
        setInitialized(true);
      }
    };

    const resetAnimation = () => {
      //showCaseRef.current.classList.add("start");
      animationWrapperRef.current.setAttribute("style", "");
      animationWrapperRef.current.classList.remove("scanning");
      animationWrapperRef.current.classList.remove("progressing");
      animationWrapperRef.current.classList.remove("dropping");
      cubeRef.current.setAttribute("style", "");
      cubeRef.current.classList.add(
        "interactive-animation-package__cube--start"
      );
      cubeRef.current.classList.remove(
        "interactive-animation-package__cube--dropping"
      );
      animationWrapperRef.current.classList.remove(
        "interactive-animation-browser--primary"
      );
      animationWrapperRef.current.classList.remove(
        "interactive-animation-browser--fr"
      );
      animationWrapperRef.current.classList.remove(
        "interactive-animation-browser--es"
      );
      animationWrapperRef.current.classList.remove(
        "interactive-animation-browser--ja"
      );
      animationWrapperRef.current.classList.remove("ready");
      animationWrapperRef.current.classList.add("empty");

      cursorRef.current.classList.remove("grabbing");
      cursorRef.current.classList.remove("click");

      cursorRef.current.setAttribute("style", "");
      packageRef.current.setAttribute("style", "");
      packageWrapperRef.current.setAttribute("style", "");
      frameWindowWrapperRef.current.setAttribute("style", "");
      cursorWrapperRef.current.setAttribute("style", "");

      langPickerESOptionRef.current.classList.remove(
        "lang-picker__widget-options__group-item--selected"
      );
      langPickerFROptionRef.current.classList.remove(
        "lang-picker__widget-options__group-item--selected"
      );
      langPickerJAOptionRef.current.classList.remove(
        "lang-picker__widget-options__group-item--selected"
      );

      new Typed(descriptionRef.current, {
        strings: [""],
        typeSpeed: 25,
      });

      setActiveLang({
        code: "EN",
        content: "Hello World!",
      });
    };

    const pause = () => {
      if (anime.running.length && _animationREF?.current) {
        _animationREF.current.pause();
        return;
      }
    };

    const play = () => {
      animationController.resetAnimation();

      if (anime.running?.length && !_animationREF?.current?.completed) {
        _animationREF.current.reset();
        _animationREF.current.restart();
        return;
      }

      _animationREF.current = anime.timeline({
        easing: "easeOutExpo",
        duration: 1000,
        autoplay: false,
        complete: function (anim) {
          //showCaseRef.current.classList.remove("start");
          setTimeout(() => {
            animationController.play();
          }, 3000);
        },
      });

      _animationREF.current
        .add({
          targets: ".js-package",
          scale: 1.5,
          opacity:1,
          rotate: "1turn",
        })
        .add({
          targets: ".js-cursor",
          left: 90,
          top: 90,
          easing: "linear",
          duration: 275,
          begin: function (anim) {
            typeAnimation &&
              new Typed(descriptionRef.current, {
                strings: ["Go to your website"],
                typeSpeed: 10,
              });
          },
          complete: function (anim) {
            new Typed(urlInputValueRef.current, {
              strings: ["", "yourwebsite.com"],
              typeSpeed: 25,
            });
            cursorRef.current.classList.add("click");

            setTimeout(() => {
              cursorRef.current.classList.remove("click");
            }, 500);
          },
        })
        .add({
          targets: ".js-cursor",
          left: animationWrapperRef.current.getBoundingClientRect().width / 2,
          top: animationWrapperRef.current.getBoundingClientRect().height + 64,
          easing: "linear",
          duration: 500,
          delay: 1000,
          begin: function (anim) {
            //_typedREF.current.destroy();
          },
          complete: function (anim) {
            animationWrapperRef.current.classList.remove("empty");
            cursorRef.current.classList.add("click");
            setTimeout(() => {
              cursorRef.current.classList.remove("click");
            }, 500);
            //onComplete
          },
        })
        .add({
          targets: ".js-package",
          scale: 1.1,
          duration: 500,
          delay: 500,
          begin: function (anim) {
            typeAnimation &&
              new Typed(descriptionRef.current, {
                strings: ["Add Lugath.js"],
                typeSpeed: 10,
              });
          },
          complete: function (anim) {
            cursorRef.current.classList.add("grabbing");
            animationWrapperRef.current.classList.add("dropping");
            //cubeRef.current.classList.add("interactive-animation-package__cube--dropping");
          },
        })
        .add({
          targets: [".js-cursor", ".js-package"],
          left: animationWrapperRef.current.getBoundingClientRect().width / 2,
          top: animationWrapperRef.current.getBoundingClientRect().height / 2,
          easing: "linear",
          duration: 500,
          begin: function (anim) {
            cursorRef.current.classList.add("click");
            setTimeout(() => {
              cursorRef.current.classList.remove("click");
            }, 500);
            animationWrapperRef.current.classList.add(
              "interactive-animation-browser--primary"
            );
            animationWrapperRef.current.classList.add("dropping");
            cubeRef.current.classList.add(
              "interactive-animation-package__cube--dropping"
            );
          },
          complete: function (anim) {
            //onComplete
          },
        })
        .add({
          targets: ".js-package",
          left:
            (animationWrapperRef.current.getBoundingClientRect().width - 64) /
            2,
          top: animationWrapperRef.current.getBoundingClientRect().height + 32,
          duration: 500,
          begin: function (anim) {
            typeAnimation &&
              new Typed(descriptionRef.current, {
                strings: [
                  "It will analyze and translate the content with Lugath AI",
                ],
                typeSpeed: 10,
              });
          },
          complete: function (anim) {
            //onComplete
            animationWrapperRef.current.classList.remove(
              "interactive-animation-browser--primary"
            );
            cursorRef.current.classList.remove("grabbing");
            animationWrapperRef.current.classList.remove("dropping");
            cubeRef.current.classList.remove(
              "interactive-animation-package__cube--dropping"
            );
            animationWrapperRef.current.classList.add("progressing");
            cubeRef.current.classList.add(
              "interactive-animation-package__cube--processing"
            );
          },
        })
        .add({
          targets: ".js-animation-wrapper",
          scale: 1.1,
          duration: 500,
          complete: function (anim) {},
        })
        .add({
          targets: ".js-animation-wrapper",
          scale: 1.1,

          duration: 1000,
          begin: function (anim) {
            cubeRef.current.classList.add(
              "interactive-animation-package__cube--processing"
            );
            cubeRef.current.setAttribute("style", "");
            animationWrapperRef.current.classList.add("scanning");
          },
        })
        .add({
          targets: ".js-package",
          scale: [
            { value: 1.5, duration: 500 },
            { value: 1, duration: 50, easing: "easeOutExpo" },
            { value: 1.5, duration: 500 },
            { value: 1, duration: 500, easing: "easeOutExpo" },
            { value: 1.5, duration: 500 },
            { value: 1, duration: 500, easing: "easeOutExpo" },
          ]/*,
          rotate: [
            { value: 2, duration: 1000 },
            { value: 1, duration: 1000, easing: "easeOutExpo" },
            { value: 2, duration: 1000 },
            { value: 1, duration: 1000, easing: "easeOutExpo" },
            { value: 2, duration: 1000 },
            { value: 1, duration: 1000, easing: "easeOutExpo" },
          ],*/
        })
        .add({
          targets: ".js-animation-wrapper",
          scale: 1,
          duration: 1000,
          complete: function (anim) {
            animationWrapperRef.current.classList.remove("scanning");
            animationWrapperRef.current.classList.add("ready");
            cubeRef.current.classList.remove(
              "interactive-animation-package__cube--processing"
            );
          },
        })
        .add({
          targets: ".js-lang-picker",
          scale: 1.2,
          duration: 500,
          easing: "easeInOutCirc",
          begin: function (anim) {
            typeAnimation &&
              new Typed(descriptionRef.current, {
                strings: [
                  "Click to language picker to view in another language",
                ],
                typeSpeed: 10,
              });
          },
          complete: function (anim) {},
        })
        .add({
          targets: ".js-lang-picker",
          scale: 1,
          duration: 1000,
          easing: "easeInOutCirc",
          complete: function (anim) {
            animationWrapperRef.current.classList.remove("progressing");
            langPickerRef.current.classList.add("show");
          },
        })
        .add({
          targets: ".js-cursor",
          left: animationWrapperRef.current.getBoundingClientRect().width - 64,
          top: animationWrapperRef.current.getBoundingClientRect().height - 64,
          duration: 400,
          complete: function (anim) {
            cursorRef.current.classList.add("click");
            setTimeout(() => {
              cursorRef.current.classList.remove("click");
            }, 500);
            //onComplete
          },
        })
        .add({
          targets: ".js-cursor",
          left: animationWrapperRef.current.getBoundingClientRect().width - 64,
          top: animationWrapperRef.current.getBoundingClientRect().height - 196,
          delay: 500,
          duration: 500,
          complete: function (anim) {
            langPickerESOptionRef.current.classList.remove(
              "lang-picker__widget-options__group-item--selected"
            );
            langPickerFROptionRef.current.classList.add(
              "lang-picker__widget-options__group-item--selected"
            );
            langPickerJAOptionRef.current.classList.remove(
              "lang-picker__widget-options__group-item--selected"
            );
            cursorRef.current.classList.add("click");
            setTimeout(() => {
              cursorRef.current.classList.remove("click");
            }, 500);
            //TODO : click animation

            animationWrapperRef.current.classList.add("progressing");
            cubeRef.current.classList.add(
              "interactive-animation-package__cube--processing"
            );
            const frLangData = languages.find((l) => l.code === "FR");
            setActiveLang(frLangData);
            langPickerRef.current.classList.remove("show");
            typeAnimation &&
              new Typed(descriptionRef.current, {
                strings: ["See the magic!"],
                typeSpeed: 10,
              });
            //onComplete
          },
        })
        .add({
          targets: ".js-animation-wrapper",
          scale: 1.025,
          duration: 300,
          begin: function (anim) {
            animationWrapperRef.current.classList.remove("progressing");
            animationWrapperRef.current.classList.add(
              "interactive-animation-browser--fr"
            );
          },
          complete: function (anim) {
            animationWrapperRef.current.classList.remove(
              "interactive-animation-browser--fr"
            );
            animationWrapperRef.current.setAttribute("style", "");
          },
        })
        .add({
          targets: ".js-lang-picker",
          scale: 1,
          duration: 1000,
          easing: "easeInOutCirc",
          complete: function (anim) {
            animationWrapperRef.current.setAttribute(
              "style",
              "transform:scale(1);"
            );
            animationWrapperRef.current.classList.remove("progressing");
            cubeRef.current.classList.remove(
              "interactive-animation-package__cube--processing"
            );
            langPickerRef.current.classList.add("show");
          },
        })
        .add({
          targets: ".js-cursor",
          left: animationWrapperRef.current.getBoundingClientRect().width - 64,
          top: animationWrapperRef.current.getBoundingClientRect().height - 64,
          duration: 500,
          begin: function (anim) {
            console.log(cursorRef, selectedLangRef);
          },
          complete: function (anim) {
            //onComplete
          },
        })
        .add({
          targets: ".js-cursor",
          left: animationWrapperRef.current.getBoundingClientRect().width - 64,
          top: animationWrapperRef.current.getBoundingClientRect().height - 148,
          delay: 500,
          duration: 500,
          begin: function (anim) {},
          complete: function (anim) {
            cursorRef.current.classList.add("click");

            setTimeout(() => {
              cursorRef.current.classList.remove("click");
            }, 500);
            cubeRef.current.classList.add(
              "interactive-animation-package__cube--processing"
            );
            langPickerESOptionRef.current.classList.add(
              "lang-picker__widget-options__group-item--selected"
            );
            langPickerFROptionRef.current.classList.remove(
              "lang-picker__widget-options__group-item--selected"
            );
            langPickerJAOptionRef.current.classList.remove(
              "lang-picker__widget-options__group-item--selected"
            );

            //TODO : click animation

            animationWrapperRef.current.classList.add("progressing");
            
            const esLangData = languages.find((l) => l.code === "ES");
            setActiveLang(esLangData);
            langPickerRef.current.classList.remove("show");
            //onComplete
          },
        })
        .add({
          targets: ".js-animation-wrapper",
          scale: 1.025,
          duration: 500,
          begin: function (anim) {
            animationWrapperRef.current.classList.remove("progressing");
            

            animationWrapperRef.current.classList.remove(
              "interactive-animation-browser--fr"
            );
            animationWrapperRef.current.classList.add(
              "interactive-animation-browser--es"
            );
          },
          complete: function (anim) {
            animationWrapperRef.current.classList.remove(
              "interactive-animation-browser--es"
            );
            animationWrapperRef.current.setAttribute("style", "");
            cubeRef.current.classList.remove(
              "interactive-animation-package__cube--processing"
            );
          },
        });

      _animationREF.current.play();
    };

    return {
      init: init,
      play: play,
      pause: pause,
      resetAnimation: resetAnimation,
    };
  })();

  const onClickPlay = () => {
    //animationController.play();
    if (showCaseRef.current.classList.contains("start")) {
      //showCaseRef.current.classList.remove("start");
    } else {
      //showCaseRef.current.classList.add("start");
    }
    //animationController.pause();
  };

  const onResize = () => {
    if (anime.running?.length && typeof _animationREF?.current !== null) {
      _animationREF?.current?.reset();
      animationController?.resetAnimation();
      return;
    }
    animationController.play();
  };

  const registeredFunc = (event) => {
    setTimeout(() => {
      animationController.init();
      animationController.play();
    }, [1000]);
  };

  useEffect(() => {
    registeredFunc();
  }, [document]);

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div className="interactive-animation__wrapper shadow-xl" onClick={onClickPlay}>
      <div className="interactive-animation__container">
        <div
          className="interactive-animation-package__wrapper js-package-initial"
          ref={packageWrapperRef}
        >
            <div
              className="interactive-animation-package js-package"
              ref={packageRef}
            >
              <div
                className="interactive-animation-package__cube"
                ref={cubeRef}
              >
                <div className="interactive-animation-package__cube-face interactive-animation-package__cube-face--1"></div>
                <div className="interactive-animation-package__cube-face interactive-animation-package__cube-face--2">
                  <LugathLogo className="cube-lugath-icon" />
                  <LoadingIcon className="cube-loading-icon" />
                </div>
                <div className="interactive-animation-package__cube-face interactive-animation-package__cube-face--3"></div>
                <div className="interactive-animation-package__cube-face interactive-animation-package__cube-face--4"></div>
                <div className="interactive-animation-package__cube-face interactive-animation-package__cube-face--5"></div>
                <div className="interactive-animation-package__cube-face interactive-animation-package__cube-face--6"></div>
                <div className="interactive-animation-package__cube-face interactive-animation-package__cube-face--shadow"></div>
              </div>
            </div>
        </div>
        <div
          className="interactive-animation-description__wrapper js-description-initial"
          ref={descriptionWrapperRef}
        >
          <div
            className="interactive-animation-description js-description"
            ref={descriptionRef}
          ></div>
        </div>
        <div
          className="interactive-animation-cursor__wrapper js-cursor-initial"
          ref={cursorWrapperRef}
        >
          <div
            className="interactive-animation-cursor js-cursor"
            ref={cursorRef}
          >
            <CursorIcon className="cursor-icon" />
            <GrabbingIcon className="grabbing-icon" />
            <div className="circle pulse" ref={cursorPulseRef}></div>
          </div>
        </div>
        {/*<div className="interactive-animation-browser js-animation-wrapper scaling scanning progressing dropping ready empty"> */}
        <div
          className="interactive-animation-browser empty js-animation-wrapper"
          ref={animationWrapperRef}
        >
          <div className="scanner"></div>
          <div className="loading">
            <LoadingIcon />
          </div>
          <div
            className="lang-picker js-lang-picker-wrapper"
            ref={langPickerWrapperRef}
          >
            <div
              className="lang-picker__widget js-lang-picker"
              ref={langPickerRef}
            >
              <div
                className="lang-picker__widget-selected js-lang-picker-selected-lang"
                ref={selectedLangRef}
              >
                <span
                  className="lang-picker__widget-selected__value js-lang-picker-selected-lang-value"
                  ref={selectedLangValueRef}
                >
                  {activeLang.code}
                </span>
              </div>
              <div
                className="lang-picker__widget-options"
                ref={langPickerOptionsRef}
              >
                <div className="lang-picker__widget-options__group">
                  <div
                    className="lang-picker__widget-options__group-item js-lang-picker-lang-fr"
                    ref={langPickerFROptionRef}
                  >
                    FR
                  </div>
                  <div
                    className="lang-picker__widget-options__group-item js-lang-picker-lang-esr"
                    ref={langPickerESOptionRef}
                  >
                    ES
                  </div>
                  <div
                    className="lang-picker__widget-options__group-item js-lang-picker-lang-ja"
                    ref={langPickerJAOptionRef}
                  >
                    JA
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="interactive-animation-browser__frame">
            <div className="interactive-animation-browser__frame-top">
              <div className="interactive-animation-browser__frame-top__close">
                <div className="interactive-animation-browser__frame-top__close-dot-group">
                  <div className="interactive-animation-browser__frame-top__close-dot-group__item"></div>
                  <div className="interactive-animation-browser__frame-top__close-dot-group__item"></div>
                  <div className="interactive-animation-browser__frame-top__close-dot-group__item"></div>
                </div>
              </div>
              <div className="interactive-animation-browser__frame-top__url">
                <div className="interactive-animation-browser__frame-top__url-bar">
                  <div className="interactive-animation-browser__frame-top__url-bar__icon">
                    <LockIcon />
                  </div>
                  <div
                    className="interactive-animation-browser__frame-top__url-bar__input"
                    ref={urlInputRef}
                  >
                    <span
                      className="interactive-animation-browser__frame-top__url-bar__input-value"
                      ref={urlInputValueRef}
                    ></span>
                    <span className="interactive-animation-browser__frame-top__url-bar__input-value--path">
                      /{activeLang.code}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="interactive-animation-browser__frame-window">
              <div className="interactive-window-content">
                <div
                  className="interactive-window-content__center js-frame-window"
                  ref={frameWindowWrapperRef}
                ></div>
                <div className="interactive-window-content__left">
                  <div className="interactive-window-content__left-top">
                    <div className="interactive-window-content__left-top__title">
                      {activeLang.content}
                    </div>
                  </div>
                  <div className="interactive-window-content__left-center">
                    <div className="interactive-window-content__left-center__skeleton-group">
                      <div className="interactive-window-content__left-center__skeleton-group__item"></div>
                      <div className="interactive-window-content__left-center__skeleton-group__item"></div>
                      <div className="interactive-window-content__left-center__skeleton-group__item"></div>
                      <div className="interactive-window-content__left-center__skeleton-group__item"></div>
                    </div>
                  </div>
                  <div className="interactive-window-content__left-bottom">
                    <div className="interactive-window-content__left-bottom__cta">
                      <div className="interactive-window-content__left-bottom__cta-btn"></div>
                    </div>
                  </div>
                </div>
                <div className="interactive-window-content__right">
                  <div className="interactive-window-content__right-image">
                    <div className="interactive-window-content__right-image__item">
                      <VideoIcon />
                    </div>
                    <div className="interactive-window-content__right-image__item">
                      <ImagesIcon />
                    </div>
                    <div className="interactive-window-content__right-image__link">
                      <LinkIcon />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
